import React from 'react';
import NexusGateway from '../components/NexusGateway';

const Home: React.FC = () => {
  return (
    <div className="py-2 sm:py-4 text-gray-800 min-h-[70vh]">
      <NexusGateway />
    </div>
  );
};

export default Home;
